<template>
  <WarmupFloat v-if="shouldShowWarmupFloat" />
  <Transition name="warning-dialog" appear :duration="{ enter: 500, leave: 200 }">
    <WarningDialog v-if="shouldShowWarningDialog" />
  </Transition>
  <RainCanvas v-if="shouldShowRainCanvas" />
  <!-- v-if="shouldShowResultDialog"  -->
  <ResultDialog />
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useRedPacketRain } from '@/composables/useRedPacketRain'
import { useToken } from '@/composables/useToken'
import WarmupFloat from './WarmupFloat.vue'
import WarningDialog from './WarningDialog.vue'
import RainCanvas from './RainCanvas.vue'
import ResultDialog from './ResultDialog.vue'
const { isLoggedIn } = useToken()
const { shouldShowWarmupFloat, shouldShowWarningDialog, shouldShowRainCanvas, initConfig } =
  useRedPacketRain()

onMounted(() => {
  initConfig()
})

// 监听登录状态
watch(isLoggedIn, (value) => {
  if (value) {
    initConfig()
  }
})
</script>
